import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

interface propsPaginationTable {
    shape: "round" | "rounded" | undefined,
    countPages: number,
    page: number,
    handleChange: (event: any, value: any) => void,
    defaultPage: number,
    styleCLasses?: string,
    setCurrentPage: (value: number) => void,
    setPerPage: (value: number) => void,
    optionsPerPage: number[],
    arrayItens: any,
    textSingle: string,
    textPlural: string,
    perPage: number
}

export const PaginationTable = (props: propsPaginationTable) => {
    const classes = useStyles();

    return (
        <div className="pagination">
            <span style={{ fontWeight: 'bold' }}>{props.arrayItens !== null ? Object.keys(props.arrayItens).length : 0}{props.arrayItens !== null && Object.keys(props.arrayItens).length === 1 ? " " + props.textSingle : " " + props.textPlural}</span>
            <div className={classes.root}>
                <Pagination shape={props.shape} count={props.countPages} page={props.page} onChange={props.handleChange} defaultPage={props.defaultPage} />
            </div>
            <div className={`perpage-pagination${props.styleCLasses ? " " + props.styleCLasses : ""}`}>
                {props.optionsPerPage.map((option, index ) => {
                    return (
                        <span key={index} style={{textDecoration: option === props.perPage ? 'underline' : 'none'}} onClick={() => { props.setCurrentPage(1); props.setPerPage(option) }}>{option}</span>
                    )
                })}
            </div>
        </div>
    );
}